import { Component, Input, OnInit } from '@angular/core';
import { ReceiptModel } from '../../model/receipt.model';
import { CommonSharedServiceService } from '../../shared-services/common-shared-service/common-shared-service.service';
import jsPDF from 'jspdf';

@Component({
  selector: 'app-receipts',
  templateUrl: './receipts.component.html',
  styleUrl: './receipts.component.scss',
})
export class ReceiptsComponent implements OnInit {
  public showPopup: boolean = false;
  @Input() receipt: ReceiptModel = {
    invoice_no: '71NXMA9X',
    invoice_to: 'Md. Rashedul Hasan',
    invoice_date: new Date(),
    label2Name: 'Address',
    label2Value: '53, Paltan, Dhaka',
    payment_method: 'N/A',
    paid_to: 'Campaigns',
    firstColumnName: 'Organization',
    firstColumnValue: 'Brac Bangladesh',
    secondColumnName: 'Campaign',
    secondColumnValue: 'Flood Relief Fund - 2024',
    thirdColumnName: 'Amount',
    thirdColumnValue: '10000',
    total_amount: '10000',
  };

  @Input() receipt_file: any = null;
  public zoomIndex: number = 1;

  constructor(private readonly sharedService: CommonSharedServiceService) {}

  ngOnInit(): void {
    this.sharedService.receiptPopupState$.subscribe((state) => {
      this.showPopup = state;
    });
  }

  public clearReceipt(): void {
    console.log('clearReceipt');
    this.receipt = new ReceiptModel();
  }

  public getType(value: any): string {
    return typeof value;
  }

  public downloadPDF() {
    const pdf = new jsPDF();
    const content = document.getElementById('receipt_pdf');

    // Converting the image to Base64 and add it manually
    const img = new Image();
    img.src = './assets/images/logo/shohay-updated-logo.svg'; // Make sure this path is correct
    img.crossOrigin = 'Anonymous'; // Ensure CORS issues are avoided

    img.onload = () => {
      const canvas = document.createElement('canvas');
      const ctx = canvas.getContext('2d');
      canvas.width = img.width;
      canvas.height = img.height;
      ctx?.drawImage(img, 0, 0);
      const imgData = canvas.toDataURL('image/png'); // Convert to Base64

      if (content) {
        pdf.html(content, {
          callback: (pdfInstance) => {
            pdfInstance.addImage(imgData, 'PNG', 10, 10, 50, 20); // Adjust position and size
            pdfInstance.save('money_receipt.pdf');
          },
          x: 10,
          y: 30, // Move content below the logo
          width: 190,
          windowWidth: 1100,
        });
      }
    };
  }

  public zoom(value: number): void {
    this.zoomIndex += value;
  }

  public downloadFile(fileUrl: string): void {
    window.open(fileUrl, '_blank');
  }
}
